module.exports = __webpack_public_path__ + "img/PD1505111928144527360.4725295c.png";